import React, { useEffect, useState } from 'react';
import { GeoUserRegion } from '@search/geo/src/GeoUserRegion';
import { IRegion } from '@search/geo/src/geoRootRegionFallback';
import classname from '@search/classname/src';
import { Toast } from '../Toast/Toast';

const cn = classname.bind(null, 'RegionSwitch');

import './styles.css';

const MAX_TEXT_LENGTH = 25;

const RegionSwitch = ({
    regionId,
    rootRegion,
    isMobile = false,
    isHeaderVisible = false
}: {
        regionId: number;
        rootRegion?: IRegion;
        isMobile?: boolean;
        isHeaderVisible?: boolean;
    }) => {
    const [ isVisible, setVisible ] = useState(false);
    const [ isSwitchedRegion, setIsSwitchedRegion ] = useState(false);
    const { userRegionId } = new GeoUserRegion();
    const text = `Ваш регион ${rootRegion?.displayName}?`;
    const isLong = text.length > MAX_TEXT_LENGTH;

    useEffect(() => {
        const switchedRegion = sessionStorage?.getItem('region-switch-modal');

        setIsSwitchedRegion(Boolean(switchedRegion));

        if (switchedRegion || userRegionId === regionId) {
            return;
        }

        setTimeout(() => {
            setVisible(true);
        }, 3000);
    }, []);

    const handleClose = () => {
        sessionStorage?.setItem('region-switch-modal', `${regionId}`);
        setIsSwitchedRegion(true);
    };

    const handleRegionChange = () => {
        const regionButton = document.querySelector('[data-test="detect-region-btn"]') as HTMLElement;

        regionButton?.click();
        handleClose();
    };

    return (
        <div className={cn(null, { mobile: isMobile })}>
            {
                ! isSwitchedRegion && userRegionId !== regionId ?
                    <Toast
                        text={text}
                        buttonText={isMobile && ! isLong ? 'Другой' : 'Выбрать другой'}
                        isVisible={isVisible}
                        buttonClick={handleRegionChange}
                        onClose={handleClose}
                        isMobile={isMobile}
                        isHeader={isHeaderVisible && ! isMobile}
                        isLong={isLong && isMobile}
                    /> : null
            }

        </div>
    );
};

export default RegionSwitch;
